import React, {useContext} from "react";
import logo from '../../images/logo.png';
import './style.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { AuthContext } from "../../context/AuthContext";


export default function Navigator(){
  const { isLoggedIn, logout } = useContext(AuthContext);
  const handleLogout = async () => {
    try {
      // 백엔드 서버의 로그아웃 엔드포인트 호출
      const response = await fetch('/api/logout', { method: 'GET' });

      if (response.ok) {
        // 성공적으로 로그아웃되면 상태 업데이트
        logout();
        sessionStorage.removeItem('user'); // sessionStorage에서 사용자 정보 제거
        // 로그아웃 후 필요한 UI 변경 또는 리디렉션 수행
        // 예: 로그인 페이지로 이동
      } else {
        console.error('Failed to logout');
      }
    } catch (error) {
      console.error('Logout error:', error);
    }
  };


    return(
        <div className='menu' >

          <div className='leftLogo'>
            <Link to={'/'}><img src={logo} alt='로고'/></Link>
          </div>

          {/* 오른쪽 메뉴 */}
          <ul className='rightNav'>
            
            <li><Link to={'/BoardPage'}>라이브러리</Link></li>
            <li><Link to={'/HelpBoardPage'}>고객지원</Link></li>
            {isLoggedIn ? (
            <label style={{cursor:'pointer'}} onClick={handleLogout}>로그아웃</label>
      ) : (
        <li><Link to={'/Login'}>로그인</Link></li>

      )}
            <li><Link to={'/Mypage'}><FontAwesomeIcon icon={faUser} /></Link></li>
            
          </ul>        
        </div>
    );
}
